import { EntityMetadataMap } from '@ngrx/data';

const sortById = (a: { id: number }, b: { id: number }) => Math.max(a.id, b.id);
export const defAdditionalCollectionState = {
  extra: {
    count: 0,
    total: 0,
    page: 0,
    pageCount: 0,
  },
};
const defEntityMeta = {
  additionalCollectionState: defAdditionalCollectionState,
};
/**
 * @param  appEntitiesEnum
 * @returns {}
 */
export function metaDataGenerator(appEntitiesEnum: any): EntityMetadataMap {
  const obj: {
    [key: string]: {
      /**
       *
       */
    };
  } = {};
  Object.keys(appEntitiesEnum).forEach((key: string) => {
    obj[appEntitiesEnum[key]] = defEntityMeta;
  });
  return obj;
}

/**
 * @param appEntitiesEnum
 * @returns
 */
export function pluralNamesGenerator(appEntitiesEnum: any) {
  const obj: {
    [key: string]: string;
  } = {};
  Object.keys(appEntitiesEnum).forEach((key: string) => {
    obj[appEntitiesEnum[key]] = appEntitiesEnum[key];
  });
  return obj;
}
